export const navigation = [
  { label: 'Inicio', href: '/' },
  { label: 'Nosotros', href: '/nosotros/' },
  { label: 'Servicios', href: '/servicios/' },
  { label: 'Proyectos', href: '/proyectos/' },
  { label: 'Noticias', href: '/noticias/' },
]

export const services = [
  {
    number: '01',
    title: 'Pilas de cimentación in-situ',
    description: 'Ejecución íntegra en distintos diámetros y profundidades, con maquinaria adecuada al elemento y al suelo.',
    image: 'perforacion-nocturna',
  },
  {
    number: '02',
    title: 'Fabricación e hincado de pilotes',
    description: 'Fabricación controlada, logística de traslado e hincado con trazabilidad y rendimiento en campo.',
    image: 'equipo-campo',
  },
  {
    number: '03',
    title: 'Tablestacado metálico y de concreto',
    description: 'Suministro e instalación de sistemas para contención, protección de excavaciones y obras hidráulicas.',
    image: 'puente-rizo-de-oro',
  },
  {
    number: '04',
    title: 'Muros Milán y Berlín',
    description: 'Soluciones de contención profunda adaptadas a las restricciones estructurales y urbanas del proyecto.',
    image: 'maquinaria-panoramica',
  },
  {
    number: '05',
    title: 'Pantallas de pilas secantes',
    description: 'Muros continuos de alta rigidez para controlar deformaciones, filtraciones y condiciones complejas del terreno.',
    image: 'perforadora-vertical',
  },
  {
    number: '06',
    title: 'Renta de maquinaria',
    description: 'Perforadoras hidráulicas Casagrande, certificadas y disponibles con operadores experimentados en todo México.',
    image: 'perforadora',
  },
]

export const projects = [
  {
    title: 'Puente Internacional Reynosa–Pharr II',
    location: 'Reynosa, Tamaulipas',
    discipline: 'Infraestructura fronteriza',
    image: 'puente-reynosa',
    href: '/puente-internacional-reynosa-pharr-ii/',
  },
  {
    title: 'Puente Rizo de Oro',
    location: 'La Concordia, Chiapas',
    discipline: 'Cimentación en cauce',
    image: 'puente-rizo-de-oro',
    href: '/puente-rizo-de-oro-chiapas/',
  },
  {
    title: 'Aeropuerto Puerto Escondido',
    location: 'Puerto Escondido, Oaxaca',
    discipline: 'Infraestructura aeroportuaria',
    image: 'aeropuerto-puerto-escondido',
    href: '/aeropuerto-puerto-escondido/',
  },
  {
    title: 'Operación de gran diámetro',
    location: 'Cobertura nacional',
    discipline: 'Perforación especializada',
    image: 'obra-aerea',
    href: '/perforaciones-de-3-00m-diametro/',
  },
]

export const news = [
  {
    category: 'Obra reciente',
    title: 'Colina Park Tijuana',
    excerpt: 'La edificación vertical impulsa nuevas soluciones de cimentación profunda en una de las regiones más dinámicas del país.',
    image: 'obra-tijuana',
  },
  {
    category: 'Infraestructura',
    title: 'Puente Internacional Reynosa–Pharr II',
    excerpt: 'Una ampliación estratégica para el comercio entre México y Estados Unidos que exige planeación y ejecución precisa.',
    image: 'puente-reynosa',
  },
  {
    category: 'Información técnica',
    title: 'Pilas secantes o tangentes',
    excerpt: 'Criterios básicos para elegir un sistema de contención según suelo, agua, deformación permitida y entorno construido.',
    image: 'equipo-campo',
  },
  {
    category: 'Seguridad',
    title: 'Rendimiento sin atajos',
    excerpt: 'Cómo integrar seguridad, certificación de maquinaria y control operativo desde el programa de ejecución.',
    image: 'maquinaria-panoramica',
  },
]

export const contact = {
  phoneLabel: '+52 (55) 6994-3897',
  phoneHref: 'tel:+525569943897',
  email: 'contacto@crscimentaciones.com.mx',
  whatsapp: 'https://wa.me/525569943897',
  hours: 'Lun–Vie · 09:00–18:00',
}
